export default "__VITE_ASSET__54c90bfc__"